// extracted by css-extract-rspack-plugin
export default {"cls1":"CreateSocialItemModal-cls1_U3q","cls2":"CreateSocialItemModal-cls2_5Pk CreateSocialItemModal-cls1_U3q"};